import { Size } from '../math/size'
import { Point } from '../math/point'
import { Viewport } from './view-transform'

// HD   16:9 1280x720
// HD   16:9 1920x1080
// SVGA  4:3  800x600
// QVGA  4:3  320x240 (dos games)

// screen size in pixels
export const screen = new Size(1280, 720) // HD 16:9
// edit `src/app/app.component.css` for width
// grid size in pixels without sprite scaling: 504px

// side of a sprite in screen pixels
const spriteLength = 32
// const spriteScale  = 1.3888 // x 24 = 33.3312

// total width of grid in number of squares
export const gameGridSquares = 21

// viewable world in screen pixels
const viewportLength = gameGridSquares * spriteLength

// position of upper left corner of viewport on screen in pixels
const viewportPosition = new Point(10, 10)

export const viewport = new Viewport(viewportLength, viewportPosition)

